<template>
  <v-container>
    <loader :isLoading="isLoading"></loader>
    <template v-if="mutualTransferAgreement?._id">
      <v-row justify="end">
        <v-col md="2">
          <v-btn
            color="blue"
            dark
            text
            @click="onClickViewDocument"
          >
            View Document
          </v-btn>
        </v-col>
      </v-row>
    </template>
    <form-component
      :formData="formData"
    >
    </form-component>
  </v-container>
</template>

<!-- eslint-disable no-underscore-dangle -->
<script>
import Loader from '../../../components/utilities/Loader.vue';
import FormComponent from '../../../components/ui/FormComponent.vue';
// import WidgetComponent from '../../../components/ui/WidgetComponent.vue';

export default {
  name: 'MutualTransferAgreementForm',
  components: {
    Loader,
    // WidgetComponent,
    FormComponent,
  },
  props: {
    onSubmit: Function,
    isLoading: Boolean,
    mutualTransferAgreement: Object,
  },
  data() {
    const documentId = this.mutualTransferAgreement?._id
      ? `${this.mutualTransferAgreement?.document?._id}.pdf`
      : '';
    return {
      formData: {
        onSubmit: this.onSubmit,
        model: this.mutualTransferAgreement,
        widgets: [
          {
            type: 'text',
            name: 'name',
            label: 'Name',
            value: '',
            counter: 50,
            maxLength: 50,
            rules: [
              (v) => !!v || 'Name is required',
            ],
          },
          {
            type: 'textarea',
            name: 'description',
            label: 'Description',
            value: '',
            counter: 200,
            maxLength: 200,
            rules: [
              (v) => !!v || 'Description is required',
            ],
          },
          {
            type: 'file',
            name: 'attachment',
            // eslint-disable-next-line no-underscore-dangle
            label: documentId,
            multiple: false,
            accept: '.pdf',
            ...(!this.mutualTransferAgreement?._id && { maxNumberOfFiles: 1 }),
            value: null,
          },
          {
            type: 'button',
            btnType: 'submit',
            name: 'save',
            label: 'Save',
            color: 'primary',
            value: null,
          },
        ],
      },
    };
  },
  methods: {
    redirectToViewDocument() {
      window.open(this.mutualTransferAgreement.document.url, '_blank');
    },
    onClickViewDocument() {
      this.redirectToViewDocument();
    },
  },
};
</script>
